import '@zebra-fed/icons/Enterprise/index.css';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from "react-router";
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Select from '@material-ui/core/Select';
import { SelectField } from "../../../components/modals/Styles";
import { Link } from "react-router-dom";
import firebaseUtil from '../../../data/FirebaseUtil';
import moment from 'moment';
import { CircularProgress } from '@material-ui/core';
import './index.css';
import {useTranslation} from "react-i18next";
import {
  Heading,
  Summary,
  EventHeading,
  InfoHeading,
  HeadingWithFilter,
  ViewEvents,
  SecondHeading,
  EventRule,
  SingleEvent,
  GeneralInfo,
  Bold,
  Line,
  Container,
  SideMargin,
  HeadingWithDate,
  Date,
  BottomMargin
} from '../report-style'
import {AUTOMATION_RULES} from '../../../data/constants';
export default function EventCategoryPage() {
  const history = useHistory();
  let categoryOptions = ["Found", "To Be Found"];
  let eventOptions = ["Manual", "Automatic"];
  const [category, setCategory] = useState(history?.location?.state?.category);
  //const [show, setShow] = useState("Manual");
  const [siteEvents, setSiteEvents] = useState({events:[],avgTimeTobeFound:"",totalTimeTobeFound:"",totalEventCount:""});
  const dateRange = {fromDate:history?.location?.state?.fromDate, toDate:history?.location?.state?.toDate};
  const siteName = history?.location?.state?.siteName;
  const [isLoading,setIsLoading] = useState(false)
  const [isMenual,setIsMenual] = useState(false)
  const {t} = useTranslation();
  useEffect(() => {
    //GET DATA
    fetchSitesEvent();
  }, [category]);

  const fetchSitesEvent = ()=>{
    setIsLoading(true);
    firebaseUtil.getSiteEvents({
      startDate:moment(history?.location?.state?.fromDate).format('YYYY-MM-DD'),
      endDate:moment(history?.location?.state?.toDate).format('YYYY-MM-DD'),
      siteName:history?.location?.state?.siteName,
      category:category
    }).then(reponse=>{
      let response = reponse.data;
      console.log(response);
      console.log("response.events.length ",response.events.length, "pp", response.events.length == 0)
      if(response.events.length == 0 ){
        console.log("{state:history?.location?.state} === ",{state:history?.location?.state})
        history.push({
          pathname: "site-event",
          state: {
            ...history?.location?.state,
            backToEventCount:true,
          }
        });
      }
        

      setIsMenual(response.events.some(arr => arr.deviceStateUpdatedBy === 0 ))
      response.events.sort((a, b) => b.count - a.count);
      response.events.sort((a,b)=> a.deviceStateUpdatedBy-b.deviceStateUpdatedBy);
      response.events = response.events.map(event=>{
          event = {...event,rule:AUTOMATION_RULES[event.subCategory]};
          return event;
      })
      console.log(response.events);
      setSiteEvents(response);
      setIsLoading(false);
    })
    .catch(err=>{
      setIsLoading(false);
      console.log("Error in fetch site is",err);
    })
  }
  return (
    <Container style={{ cursor: isLoading ? "wait" : "default", opacity: isLoading ? '0.4' : '1', position: 'relative' }}>
      {isLoading && <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
          <CircularProgress />
        </div>}
      <Summary>
        <HeadingWithFilter>
          <Heading>
            <div>
              <Button variant="contained" onClick={()=>history.goBack()} startIcon={<ArrowBackIcon />} />
            </div>
            <HeadingWithDate>
              <Bold>{siteName}</Bold>
              <Date>{moment(dateRange.fromDate).format('YYYY/MM/DD')} - {moment(dateRange.toDate).format('YYYY/MM/DD')}</Date>
            </HeadingWithDate>
          </Heading>
          <Select value={category} onChange={(e) => { setCategory(e.target.value) }}
          style={{
            padding: "5px",
            border: "1px solid #0073E6",
            borderRadius: "5px",
            color:"#0073E6"
          }}
            classes={{icon:"iconColor"}}
          >
            {
              categoryOptions.map((option,i) => {
                return (<option style={{
                  cursor: "pointer"
                }} key={"key1"+i} value={option}>{option}</option>);
              })
            }
          </Select>
        </HeadingWithFilter>
        <SecondHeading>
          <Bold>{siteEvents.totalEventCount} {t('report.events')}</Bold>
        </SecondHeading>
        {siteEvents.events.map((event, index) => {
          return (
            <div>
              <SingleEvent>
                <EventRule>
                  {event.deviceStateUpdatedBy === 0 ? 
                  <>
                  <EventHeading>{t('report.manual')}</EventHeading> 
                  <b>{event.count} {t('report.setManually')} </b>
                  </>
                  : 
                  <>
                  <EventHeading>{t('report.automatic')}</EventHeading>
                  {
                    event.rule && event.rule.toUpperCase() === 'DISCONNECTION' ? 
                    <b>{event.count} {t('report.setBy')} {event.rule}</b> : 
                    event.subCategory && event.subCategory === AUTOMATION_RULES.MACHINE_LEARNING ? 
                    <b>{event.count} {t('report.setBy')} {event.subCategory}</b> :
                    <b>{event.count} {t('report.setByRule')}: {event.rule ? event.rule.toLowerCase():null}</b>
                  }
                  
                  </>
                }
                </EventRule>
                <ViewEvents><Link to={{pathname:"/reports/site-event" ,state:{...event,...history?.location?.state,category:category}}} style={{color:"#0073E6",textDecoration: "none"}} >View Events</Link></ViewEvents>
              </SingleEvent>
              <Line />
            </div>
          );
        })}

        <SideMargin>
          <GeneralInfo>{t('report.generalInfo')}</GeneralInfo>
          {(isMenual || category === 'To Be Found' || 'At Risk') ?(
            <>
            <BottomMargin>
              <InfoHeading>{t('report.averageTime')} { category ==='Found'  ? t('Mo_Dash.placeholders.FindDeviceLabel') : category }</InfoHeading>
              <b>{siteEvents.avgTimeTobeFound}</b>    {/* atRisk or toBeFound or found avg time */}
            </BottomMargin>
            <div>
              <InfoHeading>{t('report.totalTime')} {category ==='Found' ? t('Mo_Dash.placeholders.FindDeviceLabel') : category }</InfoHeading>
              <b>{siteEvents.totalTimeTobeFound}</b>  {/* atRisk or toBeFound or found avg time */}
            </div>
            </>
          ):(<div>
            <b>NA</b>
          </div>)}
          
        </SideMargin>
      </Summary>
    </Container>
  );
}